
import { Alignment, Button, ChartData, ChartType, Checkbox, Classname, DateHelper, Dropdown, ResizeDimension, ResizeSensor, Scheme, StringHelper, useScreenDimension } from "@rivtn/noseur";
import React from "react";
import { Schemes, Utils } from "../../../utils";
import { ApiResponseData, BaseService, EarningService, IMember, IMemberCurrencyBalance, ITournamentEditionRegistered, SanitizedResponse, TournamentService, TournamentStatus } from "../../../services";
import { i18nManager } from "../../../i18n";
import * as ReactRouterDom from "react-router-dom";
import { Elements } from "../../shared/Elements";
import { InitiateWithdraw } from "../earnings/Withdrawal";
import { ChartManager } from "../../shared/ChartManager";

export interface DashboardProps {
    profile: IMember;
}

function Dashboard(props: DashboardProps) {

    const { profile } = props;
    const { width } = useScreenDimension();
    const labels = i18nManager.Labels.dashboard;
    const earningLabels = i18nManager.Labels.earnings;
    const chartDataState = React.useState<ChartData>();
    const earningService = EarningService.getInstance();
    const earningChartDataState = React.useState<ChartData>();
    const tournamentService = TournamentService.getInstance();
    const [hideBalance, setHideBalance] = React.useState<boolean>(Utils.getSetting("hb"));
    const [currencyBalance, setCurrencyBalance] = React.useState<IMemberCurrencyBalance>();
    const [searchParams, setSearchParams] = ReactRouterDom.useSearchParams(window.location.search);
    const [registeredTournamentEditions, setRegisteredTournamentEditions] = React.useState<ApiResponseData<ITournamentEditionRegistered>>({});

    React.useEffect(fetchInformation, []);
    React.useEffect(fetchCurrencyBalance, [searchParams]);

    return (<div className="dashboard">
        <div className="labels">
            <div className="texts">
                <span className="t">{labels.hello} {profile.username},</span>
                <span className="d">{labels.intro}</span>
            </div>
            {(width > 800) && (<Checkbox scheme={Schemes.OMNEHOST} label={labels.hide_balance} alignLabel={Alignment.LEFT} defaultChecked={hideBalance} onChecked={(e) => {
                setHideBalance(e);
                Utils.updateSettings("hb", e);
            }} />)}
        </div>
        <div className="top" style={(width < 800) ? { flex: "unset" } : undefined}>
            <div className="left">
                <div className="cards">
                    <div className="card available">
                        <div className="h">
                            <Dropdown borderless noIcon scheme={Scheme.LIGHT} popoverProps={{ scheme: Schemes.OMNEHOST }}
                                selectedOptionIndex={(i18nManager.CountriesAndCurrencies?.findIndex((p) => p?.currency_code === (searchParams.get("curr") ?? "NGN")) ?? 0)}
                                textInputProps={{ style: { paddingLeft: 15, color: "white" } }}
                                options={i18nManager.CountriesAndCurrencies} optionMap={{
                                    value: "currency_code",
                                    label: "{currency_name} ({currency_code})",
                                }} onSelectOption={(option) => {
                                    Utils.updateSearchParams("curr", option.currency_code, setSearchParams);
                                }} />
                            <Button rounded iconOnly className="fa fa-arrow-right" link={`/earnings/${searchParams.get("curr") ?? "NGN"}`}
                                style={{ fontWeight: 600, padding: "7px 9px", margin: 8, rotate: "-30deg", background: "var(--mainColor)", color: "#FFFFFF", borderColor: "#FFFFFF" }} />
                        </div>
                        <div className="b">
                            <div className="ls">
                                <span className={Classname.build("solo-tr")}>
                                    {Elements.TREND_ICON}
                                    <span className="lined-limit">{10} %</span>
                                </span>
                                {(!currencyBalance)
                                    ? (<div style={{ height: 30, width: 20 }}><i className="fa fa-spinner fa-spin" /></div>)
                                    : (<span className="text-shadowed lined-limit">{i18nManager.getCurrencySign(searchParams.get("curr") ?? "NGN")} {hideBalance ? "*****" : StringHelper.toPresentableMoneyValue(currencyBalance?.available_amount)}</span>)}
                                <span className="tl">{labels.available_balance}</span>
                            </div>
                            <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={() => InitiateWithdraw((searchParams.get("curr") ?? "NGN"), undefined, undefined, () => {
                                //fetchTransaction();
                                //fetchCurrencyEarnings();
                            })}>
                                <path d="M20.8516 19.6914L23.5141 22.3539C25.2816 20.312 26.2528 17.7008 26.2491 15.0002C26.2535 12.3428 25.3129 9.77041 23.5953 7.74268L20.9291 10.4089C21.9492 11.7217 22.5018 13.3376 22.4991 15.0002C22.4991 16.7752 21.8828 18.4064 20.8516 19.6914Z" fill="#6C6666" fillOpacity="0.5" />
                                <path d="M19.5904 20.9314C18.477 21.7933 17.1436 22.3244 15.7425 22.4639C14.3415 22.6034 12.9295 22.3457 11.668 21.7203C10.4066 21.0949 9.34662 20.1271 8.60946 18.9275C7.8723 17.7279 7.4877 16.3451 7.49965 14.9372C7.5116 13.5292 7.91962 12.1531 8.67703 10.9662C9.43444 9.77933 10.5107 8.82961 11.7825 8.22571C13.0544 7.62181 14.4706 7.38813 15.8691 7.55141C17.2676 7.71468 18.5918 8.2683 19.6904 9.14895L22.3529 6.48645C20.7259 5.08143 18.7304 4.17197 16.6027 3.86573C14.4749 3.55948 12.304 3.86927 10.3468 4.75842C8.3896 5.64757 6.72814 7.07886 5.55907 8.88286C4.39 10.6869 3.76227 12.7881 3.75018 14.9377C3.73809 17.0874 4.34214 19.1955 5.49084 21.0125C6.63955 22.8295 8.2848 24.2794 10.2319 25.1905C12.1789 26.1017 14.3462 26.4359 16.4773 26.1536C18.6084 25.8713 20.614 24.9843 22.2567 23.5977L19.5904 20.9314Z" fill="#085376" />
                            </svg>
                        </div>
                    </div>
                    <div className="card">
                        <div className="h">
                            <span style={{ margin: 15, fontSize: 18 }}>{labels.tournaments}</span>
                            {(width > 800) && (<Button rounded outlined iconOnly fillOnHover className="fa fa-arrow-right" scheme={Schemes.OMNEHOST} link={`/tournaments?section=REGISTERED`}
                                style={{ fontWeight: 600, padding: "7px 9px", margin: 8, rotate: "-30deg", color: "var(--textColor)", borderColor: "var(--textColor)" }} />)}
                        </div>
                        <div className="info">
                            <div>{registeredTournamentEditions.total_elements}</div>
                            <div className="texts">
                                <span>{labels.ongoing_tournaments}</span>
                                <span>{labels.expected_to_win.replaceAll("${count}", "0")}</span>
                            </div>
                        </div>
                        <ReactRouterDom.NavLink to={`/tournaments?section=REGISTERED`} style={{ margin: 15 }} className={"lined-limit"}>{labels.view_all_tournaments}</ReactRouterDom.NavLink>
                    </div>
                </div>
                <ResizeSensor minDimension={{ height: 900 }}>
                    <div className="graph">
                        <div className="t">{labels.your_matches_graph}</div>
                        {<ChartManager type={ChartType.BAR} title={labels.chart_title} chartDataState={chartDataState} style={{ margin: 0, boxShadow: "none" }} height={"stretch"} />}
                    </div>
                </ResizeSensor>
            </div>
            <ResizeSensor minDimension={{ width: 1300 }}>
                <div className="right">

                </div>
            </ResizeSensor>
        </div>
        <div className="bottom" style={(width < 800) ? { flex: 1 } : undefined}>
            <div className="tours">
                <span className="t">{labels.your_active_tournaments}</span>
                {(!registeredTournamentEditions.content) && (Elements.LOADING_STATE)}
                {(registeredTournamentEditions.content && !registeredTournamentEditions.content?.length) && (Elements.buildEmptyListView("fa fa-trophy", (<span>
                    {labels.empty_tournaments_parts.you_dont}{" "}
                    <ReactRouterDom.NavLink to="/hosts">{labels.empty_tournaments_parts.create}</ReactRouterDom.NavLink>{" "}
                    {i18nManager.Labels.common.or}{" "}
                    <ReactRouterDom.NavLink to="/tournaments">{labels.empty_tournaments_parts.search}</ReactRouterDom.NavLink>{" "}
                    {labels.empty_tournaments_parts.for_a}
                </span>), { marginTop: "15%" }))}
                <div className="list">
                    {registeredTournamentEditions?.content?.map((registeredTournamentEdition) => {
                        return (<ReactRouterDom.NavLink key={registeredTournamentEdition.external_id} to={`/tournaments/${registeredTournamentEdition.external_id}`} className="tour">
                            <img alt={registeredTournamentEdition.tournament_edition.name} src={registeredTournamentEdition.tournament_edition.banner_url} />
                            <div>
                                <img alt={registeredTournamentEdition.tournament_edition.name} src={registeredTournamentEdition.tournament_edition.logo_url} />
                                <div>
                                    <span className="n">{registeredTournamentEdition.tournament_edition.name}</span>
                                    <span className="p">{registeredTournamentEdition.tournament_edition.program.name}</span>
                                </div>
                            </div>
                            <Button rounded outlined iconOnly fillOnHover className="fa fa-arrow-right" scheme={Schemes.OMNEHOST}
                                style={{ padding: "7px 9px", margin: 8, rotate: "-30deg", color: "var(--textColor)", borderColor: "var(--textColor)" }} />
                        </ReactRouterDom.NavLink>);
                    })}
                </div>
            </div>
            <ResizeSensor minDimension={{ width: 700 }}><div className="earns">
                <div className="h">
                    <Dropdown borderless noIcon scheme={Schemes.OMNEHOST} popoverProps={{ scheme: Schemes.OMNEHOST }}
                        selectedOptionIndex={(i18nManager.CountriesAndCurrencies?.findIndex((p) => p?.currency_code === (searchParams.get("curr") ?? "NGN")) ?? 0)}
                        textInputProps={{ style: { paddingLeft: 15, color: "var(--textColor)" } }}
                        options={i18nManager.CountriesAndCurrencies} optionMap={{
                            value: "currency_code",
                            label: "{currency_name} ({currency_code})",
                        }} onSelectOption={(option) => {
                            Utils.updateSearchParams("curr", option.currency_code, setSearchParams);
                        }} />
                    <span style={{ fontSize: 18, padding: "15px 20px" }}>{labels.earnings}</span>
                </div>
                <ChartManager cannotEnlarge type={ChartType.POLARAREA} height={"100%"} title={labels.chart_title} chartDataState={earningChartDataState} options={{
                    responsive: true,
                    maintainAspectRatio: false,
                    plugins: {
                        legend: { display: false }
                    },
                    // We "squash" the chart to give it an isometric perspective
                    aspectRatio: 2,
                    layout: {
                        padding: 50
                    }
                }} plugins={[{
                    beforeDraw: (chart: any) => {
                        const ctx = chart.ctx;
                        chart.data.datasets.forEach((dataset: any, i: any) => {
                            const meta = chart.getDatasetMeta(i);
                            meta.data.forEach((element: any, index: any) => {
                                const { x, y, startAngle, endAngle, outerRadius } = element;

                                console.log("hello");
                                ctx.save();
                                ctx.beginPath();
                                ctx.fillStyle = 'rgba(0,0,0,0.15)'; // Darken for depth
                                ctx.ellipse(x, y + 15, outerRadius, outerRadius * 0.8, 0, startAngle, endAngle);
                                ctx.lineTo(x, y + 15);
                                ctx.fill();
                                ctx.restore();
                            });
                        });
                    }
                }]} />
                <div className="legends">
                    <div>
                        <div style={{ backgroundColor: "#0B831D" }} />
                        <span>{labels.in_progress}</span>
                    </div>
                    <div>
                        <div style={{ backgroundColor: "#258FD1" }} />
                        <span>{labels.pending}</span>
                    </div>
                    <div>
                        <div style={{ backgroundColor: "#D1BC1D" }} />
                        <span>{labels.available}</span>
                    </div>
                </div>
            </div>
            </ResizeSensor>
        </div>
    </div>);

    function fetchInformation() {
        setRegisteredTournamentEditions({});
        tournamentService.queryTournamentEditionRegistereds({
            status__in: [TournamentStatus.REGISTERED],
            //"tournament_edition.status__in": ["ONGOING"],
        }).then(async ({ apiResponse: { data } }: SanitizedResponse<ITournamentEditionRegistered>) => {
            setRegisteredTournamentEditions(data ?? { content: [] });
        }).catch(BaseService.reportError);
        chartDataState[1](undefined);
        tournamentService.queryMatchAnalytics({
            "extra_data.participating_members": "",
            to: searchParams.get("to") ?? Utils.formatToApiDate(new Date(), false, false)!,
            from: searchParams.get("from") ?? Utils.formatToApiDate(DateHelper.getStartOfYear(), false, false)!,
        }).then(({ apiResponse }: SanitizedResponse<any>) => {
            chartDataState[1](apiResponse.data!);
        }).catch(BaseService.reportError);
    }

    function fetchCurrencyBalance() {
        setCurrencyBalance(undefined);
        earningService.getCurrencyBalance((searchParams.get("curr") ?? "NGN"), {}).then(({ sanitized }: SanitizedResponse<IMemberCurrencyBalance>) => {
            setCurrencyBalance(sanitized);
            earningChartDataState[1]({
                labels: [labels.in_progress, labels.pending, labels.available],
                datasets: [{
                    offset: 3,
                    borderWidth: 0,
                    data: [(sanitized.in_progress_amount / 1000000), (sanitized.pending_amount / 1000000), sanitized.available_amount / 1000000],
                    backgroundColor: [
                        '#0B831D',
                        '#258FD1',
                        '#D1BC1D'
                    ],
                }]
            });
        }).catch(BaseService.reportError);
    }

}

export default Dashboard;
